import React from 'react';

const HomeIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "16",
    height: "17",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10 11.6547C9.46701 12.0696 8.76681 12.3213 8.00001 12.3213C7.23315 12.3213 6.53302 12.0696 6 11.6547",
      stroke: "#E2E4EE",
      strokeLinecap: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M1.56727 9.13035C1.33192 7.59882 1.21425 6.8331 1.50379 6.15427C1.79332 5.47543 2.43569 5.01097 3.72043 4.08206L4.68033 3.38802C6.27853 2.23246 7.07762 1.65468 7.99969 1.65468C8.92169 1.65468 9.72082 2.23246 11.319 3.38802L12.2789 4.08206C13.5637 5.01097 14.206 5.47543 14.4956 6.15427C14.7851 6.8331 14.6674 7.59882 14.4321 9.13035L14.2314 10.4363C13.8978 12.6073 13.731 13.6928 12.9524 14.3404C12.1738 14.988 11.0354 14.988 8.75889 14.988H7.24049C4.9639 14.988 3.82561 14.988 3.04701 14.3404C2.2684 13.6928 2.10159 12.6073 1.76796 10.4363L1.56727 9.13035Z",
      stroke: "#E2E4EE",
      strokeLinejoin: "round"
    }
  )
);
HomeIcon.displayName = "Icons.HomeIcon";

export { HomeIcon };
//# sourceMappingURL=HomeIcon.js.map
